import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Set as ImmutableSet, Map as ImmutableMap } from 'immutable';
import memoize from 'transmute/memoize';
import { NavMarker } from 'react-rhumb';
import getIn from 'immutable-less/transmute/getIn';
import getComponentName from 'react-utils/getComponentName';
import PostMessageTypes from 'ui-addon-automation-embed/PostMessageTypes';
import { sendMessageToParent } from 'ui-addon-automation-embed/embedUtils';
// @ts-expect-error untyped module
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { GYPSUM, KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import uniqueIdForObject from 'automation-ui-core/utils/uniqueIdForObject';
import { getIsCanvasVirtualRenderingDisabled } from 'automation-ui-canvas/selectors/platformFlowsApplicationSelectors';
import ActionConfigComponents from 'automation-ui-canvas/action-features/ActionConfigComponents';
import ActionConfigBasePaths from 'automation-ui-action-features/actions/ActionConfigBasePaths';
import { basePathToActionMetadataConfig } from 'automation-ui-action-features/actions/ActionMetadataConfigUtils';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { parseLocation, getFlowEditRoute } from 'automation-ui-routing/utils';
import AppContext from 'automation-ui-core/context/AppContext';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import * as Scopes from 'automation-ui-canvas/constants/Scopes';
import { createActionCardCounters, getActionHeaderTitle, getIsEnabled, getObjectTypeId, getActionOutputsForTargetActionById, getSourceApp as getFlowSourceApp } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import { getFlowValidation, getFlowValidationObjectRequestStatus } from 'automation-ui-canvas/selectors/flowSelectors';
import * as flowActions from 'automation-ui-canvas/actions/FlowActions';
import * as CanvasIdentifiers from 'automation-ui-flow-core/canvas/CanvasIdentifiers';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { getEmbedId, getSourceApp } from 'automation-ui-canvas/selectors/embedSelectors';
import EmbeddedCollapsedFlowAlert from 'automation-ui-canvas/components/embed/EmbeddedCollapsedFlowAlert';
import { getHighlightedActionIds } from 'automation-ui-canvas/selectors/platformFlowsApplicationSelectors';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import { fetchBulkProcessingStatus } from 'automation-ui-canvas/data/api/FlowsApi';
import * as platformFlowsApplicationActions from 'automation-ui-canvas/actions/PlatformFlowsApplicationActions';
import { BULK_ENROLL } from 'automation-ui-canvas/constants/BulkProcessingTypes';
import { getShouldPollBulkProcessing } from 'automation-ui-canvas/selectors/platformFlowsApplicationSelectors';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import DataSourcesProviderWrapper from 'automation-ui-canvas/containers/DataSourcesProviderWrapper';
import Action from 'automation-ui-action-features/records/Action';
import FlowCanvasNode from 'automation-ui-canvas/components/canvas/FlowCanvasNode';
import { wireActionOutputs } from 'automation-ui-action-features/queries/actionOutputQueries';
import { queryAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { queryObjectsInActionsPolling } from 'automation-ui-canvas/action-features/objects-in-action/ObjectsInActionQueries';
import { UNINITIALIZED } from 'redux-request-state/requestStates';
import { wireAppConfigConsumer } from 'automation-ui-source-apps/context/AppConfigContext';
import { getFlowActionCount } from 'automation-ui-canvas/utils/actionLimitUtils';
import ContextualValidationErrorBanner from 'automation-ui-canvas/components/alerts/ContextualValidationErrorBanner';
import { addAlert as _addAlert } from 'automation-ui-canvas/actions/MessageActions';
import * as AlertTypes from 'automation-ui-canvas/constants/AlertTypes';
import ActionLimit from 'automation-ui-canvas/data/records/ActionLimit';
import ContextualEmbedErrorState from 'automation-ui-canvas/components/embed/ContextualEmbedErrorState';
import ContextualCanvasAddButton from 'automation-ui-canvas/components/contextualCanvas/ContextualCanvasAddButton';
import ContextualCanvasUpgradeButton from 'automation-ui-canvas/components/contextualCanvas/ContextualCanvasUpgradeButton';
import { getActionLimitMessage } from 'automation-ui-canvas/utils/actionLimitUtils';
import { wireFlowById, wireUpdateFlow } from 'automation-ui-canvas/queries/flowQueries';
import { EDIT_ACTIONS } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { withFeaturePermissions } from 'automation-ui-permissions/feature-permissions/decorators/FeaturePermissionsDecorator';
import PannableDecorator from 'automation-ui-canvas/decorators/PannableDecorator';
import ZoomableDecorator from 'automation-ui-canvas/decorators/ZoomableDecorator';
import withFlpAccess from 'automation-ui-permissions/flp/hocs/withFlpAccess';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CONTEXTUAL_CONTROL_OVERRIDES = {
  ADD_ACTION: 'addAction',
  EDIT_ACTION: 'editAction'
};
const PROCESSING = 'PROCESSING';
const FAILURE_LIMIT = 4;
const StyledRoot = styled.div.withConfig({
  displayName: "ContextualEmbedDecorator__StyledRoot",
  componentId: "sc-1x2caaw-0"
})(["height:100%;"]);
const StyledFlowContainer = styled.div.withConfig({
  displayName: "ContextualEmbedDecorator__StyledFlowContainer",
  componentId: "sc-1x2caaw-1"
})(["&&{", "}min-width:100%;max-width:100%;height:100%;overflow:", " auto;"], ({
  isDisabled
}) => isDisabled ? `
    background: repeating-linear-gradient(
      45deg,
      ${GYPSUM},
      ${GYPSUM} 10px,
      ${KOALA} 10px,
      ${KOALA} 20px
    );
  ` : `background: ${GYPSUM}`, ({
  shouldScrollHorizontally
}) => shouldScrollHorizontally ? 'auto' : 'hidden');
const defaultProps = {
  columnWidth: 600
};
const StyledCanvas = styled.div.withConfig({
  displayName: "ContextualEmbedDecorator__StyledCanvas",
  componentId: "sc-1x2caaw-2"
})(["height:100%;"]);
function getComposedCanvas({
  shouldScrollHorizontally,
  shouldAllowZoom
}) {
  if (shouldAllowZoom && shouldScrollHorizontally) {
    return PannableDecorator(ZoomableDecorator({
      // @ts-expect-error ZoomableDecorator expects StyledCanvas to have its required props, but it's just a div
      // and the required props aren't wired until ComposedCanvas is used in FlowCanvasBase. Not sure if real error or not
      WrappedComponent: StyledCanvas,
      shouldRenderUndoRedoButtons: false
    }));
  } else if (shouldScrollHorizontally) {
    // @ts-expect-error ZoomableDecorator expects StyledCanvas to have its required props, but it's just a div
    // and the required props aren't wired until ComposedCanvas is used in FlowCanvasBase. Not sure if real error or not
    return PannableDecorator(StyledCanvas);
  } else {
    return StyledCanvas;
  }
}
export default function ContextualEmbedDecorator(WrappedComponent, centerOnMount) {
  const componentName = getComponentName(WrappedComponent);
  class ContextualAutomationContainer extends Component {
    constructor(_props) {
      super(_props);
      this.scrollElementRef = /*#__PURE__*/createRef();
      this.ComposedCanvas = getComposedCanvas(this.props.appConfigContext.config);
      this.updateContextualActionLimit = () => {
        const {
          flow
        } = this.props;
        const {
          actionLimit
        } = this.state;
        this.setState({
          actionLimit: actionLimit.setUpdatedStatus(flow)
        });
      };
      this.terminateBulkProcessingPolling = () => {
        clearInterval(this.pollProcessingStatusId);
        this.pollProcessingStatusId = -1;
      };
      this.failureCount = 0;
      this.toggleAddEmptyActionToFlow = (selectedEdgeId, forceRemove = false) => {
        const {
          flow,
          updateFlowLocally
        } = this.props;
        if (!flow) {
          return;
        }
        const emptyAction = new Action({
          actionType: ActionTypes.EMPTY_ACTION,
          actionId: SpecialActionIds.NEW_ACTION
        });
        let newFlow = flow;
        const addAction = !!selectedEdgeId;
        if (addAction && !forceRemove) {
          newFlow = newFlow.removeAction(SpecialActionIds.NEW_ACTION);
          newFlow = newFlow.insertAction({
            action: emptyAction,
            edgeId: selectedEdgeId,
            actionId: SpecialActionIds.NEW_ACTION
          });
        } else {
          newFlow = newFlow.removeAction(SpecialActionIds.NEW_ACTION);
        }
        updateFlowLocally(newFlow);
      };
      this.pollBulkProcessingStatus = (flowId, setBulkProcessingStatus, shouldPollBulkProcessing) => {
        // checking for pollProcessingStatusId to prevent multiple polls on prop change
        if (shouldPollBulkProcessing && this.pollProcessingStatusId === -1) {
          this.pollProcessingStatusId = setInterval(() => {
            fetchBulkProcessingStatus(flowId, PROCESSING).then(res => {
              this.failureCount = 0;
              const nextBulkProcessingStatus = this.parseBulkProcessingResults(res);
              setBulkProcessingStatus(flowId, nextBulkProcessingStatus);
            }).catch(error => {
              if (++this.failureCount === FAILURE_LIMIT) {
                // Not sure how to handle this other than report it to Sentry.
                reportError({
                  error
                });
              }
            });
          }, 2000);
        } else if (!shouldPollBulkProcessing) {
          this.terminateBulkProcessingPolling();
        }
      };
      this.parseBulkProcessingResults = results => {
        const actionsBulkProcessing = [];
        let enrollmentIsBulkProcessing = false;
        let shouldPollBulkProcessing = false;
        results.forEach(result => {
          const actionId = getIn(['actionId'], result);
          const processingType = getIn(['metadata', 'bulkProcessingType'], result);
          if (processingType === BULK_ENROLL) {
            enrollmentIsBulkProcessing = true;
          } else if (actionId) {
            actionsBulkProcessing.push(actionId);
          }
        });
        if (actionsBulkProcessing.length !== 0 || enrollmentIsBulkProcessing) {
          shouldPollBulkProcessing = true;
        }
        return ImmutableMap({
          actionsBulkProcessing: ImmutableSet(actionsBulkProcessing),
          enrollmentIsBulkProcessing,
          shouldPollBulkProcessing
        });
      };
      this.preloadActionConfigChunks = (props = this.props) => {
        const {
          flow
        } = props;
        if (!flow) {
          return;
        }
        flow.actions.map(action => action.actionType).toSet().forEach(actionType => {
          const LoadableConfig = ActionConfigComponents[actionType];
          if (LoadableConfig) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            LoadableConfig.preload();
          }
        });
      };
      this.handleGetActionOutputsForTargetActionById = (targetActionId, isNew) => getActionOutputsForTargetActionById({
        flow: this.props.flow,
        allOutputsByActionTypeId: this.props.allOutputsByActionTypeId,
        instanceOutputsByActionId: this.props.instanceOutputsByActionId,
        targetActionId,
        isNewAction: isNew
      });
      this.toggleSelectedEdgeId = (edgeId, remove) => {
        const {
          history
        } = this.props;
        if (remove) {
          atomicQueryUpdate({}, ['edgeId'], history, true);
        } else {
          // make sure to also remove the actionId
          atomicQueryUpdate({
            edgeId
          }, ['actionId'], history, true);
        }
      };
      this.toggleEmbeddedSelectedActionId = (actionId, remove, tab) => {
        const {
          history
        } = this.props;
        if (remove) {
          atomicQueryUpdate({}, ['actionId'], history, true);
        } else {
          // make sure to also remove the edgeId
          atomicQueryUpdate({
            actionId,
            tab
          }, ['edgeId'], history, true);
        }
      };
      this.onClickNavigateToFullApp = () => {
        const {
          flow,
          sourceApp
        } = this.props;
        trackEvent(Trackables.NAVIGATE_TO_WORKFLOWS_APP_FROM_CONTEXTUAL_EMBED, {
          sourceApp,
          type: flow.objectTypeId
        }, true);
      };
      this.onSelectAction = (id, event) => {
        const {
          tab
        } = event;
        const {
          flow,
          flowId,
          embedId
        } = this.props;
        const actionId = Number(id);
        const action = flow.getActionById(actionId);
        const actionType = action ? action.getActionType() : null;
        const configRoute = actionType ? ActionConfigBasePaths[actionType] : null;
        const configId = actionId;
        sendMessageToParent({
          type: PostMessageTypes.SELECT_ACTION,
          flowId,
          embedId,
          configId,
          actionNameRoute: configRoute,
          tab
        });
        this.toggleEmbeddedSelectedActionId(id, false, tab);
      };
      this.handleEmbedOnClickAddControl = (edgeId, removeEdgeId) => {
        const {
          flowId,
          embedId
        } = this.props;
        sendMessageToParent({
          type: PostMessageTypes.ADD_CONTROL,
          flowId,
          embedId,
          edgeId
        });
        if (removeEdgeId) {
          sendMessageToParent({
            type: PostMessageTypes.CLOSE_SIDEPANEL,
            embedId
          });
          this.toggleSelectedEdgeId(null, true);
        } else {
          this.toggleSelectedEdgeId(edgeId, false);
        }
      };
      this.onClickAddControl = edgeId => {
        const {
          flowId,
          edgeId: selectedEdgeId,
          flow
        } = this.props;
        const removeEdgeId = selectedEdgeId === edgeId;
        if (!removeEdgeId) {
          trackEvent(Trackables.ADD_ACTION_CONFIG, {
            objectTypeId: getObjectTypeId(flow),
            flowId // to ensure tracking within embed
          });
        }
        this.handleEmbedOnClickAddControl(edgeId, removeEdgeId);
      };
      this.onRenderCanvasNode = memoize(({
        id,
        width,
        height
      }) => {
        const {
          flow,
          getFeaturePermission,
          selectedActionId,
          highlightedActionIds,
          isCanvasVirtualRenderingDisabled,
          selectedActionMetadataConfig,
          objectsInActions,
          flpAccessData,
          flpAccessError
        } = this.props;
        const isHighlighted = highlightedActionIds && highlightedActionIds.has(id);
        const isSelected = selectedActionId === id.toString();
        const hasFlpWriteAccess = !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(EDIT_ACTIONS));
        const {
          hasFeatureAccess: hasEditActionAccess
        } = getFeaturePermission({
          feature: EDIT_ACTIONS
        });
        const {
          controlDisabled: editActionDisabled
        } = this.getControlDisabledOverride(CONTEXTUAL_CONTROL_OVERRIDES.EDIT_ACTION);
        const readOnly = !hasFlpWriteAccess || !hasEditActionAccess || id === CanvasIdentifiers.FIRST_NODE;
        return /*#__PURE__*/_jsx(FlowCanvasNode, {
          id: id,
          width: width,
          height: height,
          flow: flow,
          isSelected: isSelected,
          onSelectNode: this.onSelectAction,
          isHighlighted: isHighlighted,
          clickable: hasFlpWriteAccess && !editActionDisabled && id !== CanvasIdentifiers.FIRST_NODE,
          readOnly: readOnly,
          isCanvasVirtualRenderingDisabled: isCanvasVirtualRenderingDisabled,
          selectedActionMetadataConfig: selectedActionMetadataConfig,
          getActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById,
          objectsInActions: objectsInActions
        });
      },
      /**
       * This advanced memo cache key ensures action
       * cards are memoized whenever possible. This
       * is a necessary optimization to make the
       * virtual renderer smooth for large workflows.
       */
      ({
        id: nodeId
      }) => {
        const {
          contextualEmbedReadOnly,
          isContextualEmbed,
          triggerContent
        } = this.context;
        const {
          flowValidation,
          selectedActionId,
          highlightedActionIds,
          flowId,
          isCanvasVirtualRenderingDisabled,
          selectedActionMetadataConfig,
          flow,
          objectsInActions,
          isActionOutputsLoading,
          getFeaturePermission,
          flpAccessError,
          flpAccessData
        } = this.props;
        const hasFlpWriteAccess = !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(EDIT_ACTIONS));
        const {
          hasFeatureAccess: hasEditActionAccess
        } = getFeaturePermission({
          feature: EDIT_ACTIONS
        });
        const readOnly = !hasFlpWriteAccess || !hasEditActionAccess || nodeId === CanvasIdentifiers.FIRST_NODE;
        const contextualEmbedReadOnlyOverride = isContextualEmbed && contextualEmbedReadOnly;

        // Since updating actions updates the flow
        // version, this is a safe optimization to
        // avoid virtual actions triggering busting
        // this cache
        const flowVersion = flow.getVersion();
        const isHighlighted = highlightedActionIds && highlightedActionIds.has(nodeId);
        const isSelected = selectedActionId === nodeId.toString();
        let selectedActionMetadataConfigForNewAction;
        if (nodeId === SpecialActionIds.NEW_ACTION) {
          selectedActionMetadataConfigForNewAction = selectedActionMetadataConfig;
        }
        const objectsInThisAction = objectsInActions ? objectsInActions.find(delayedAction => delayedAction.actionId === nodeId) : null;
        const objectsInThisActionCount = objectsInThisAction && objectsInThisAction.count;
        return `${nodeId}-${triggerContent}-${flowVersion}-${uniqueIdForObject(flowValidation)}-${isSelected}-${isHighlighted}-${flowId}-${isCanvasVirtualRenderingDisabled}-${selectedActionMetadataConfigForNewAction}-${objectsInThisActionCount}-actionOutputsLoading:${isActionOutputsLoading}-${contextualEmbedReadOnlyOverride}-${readOnly}`;
      });
      this.getActionValidationAlerts = () => {
        const {
          flow,
          flowValidation
        } = this.props;
        const actionErrors = flowValidation.getAllActionErrors();
        const actionCounters = createActionCardCounters(flow);
        return actionErrors.groupBy(actionError => actionError.actionId).toList().map(actionError => actionError.get(0)).sortBy(actionError => actionCounters[actionError.actionId]);
      };
      this.handleRequestFlow = (props = this.props) => {
        const {
          flowId,
          flowQuery
        } = props;
        if (flowId > 0) {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          flowQuery.refetch({
            flowId
          });
        }
      };
      this.handleMessage = message => {
        const {
          flowId
        } = this.props;
        const {
          data = {}
        } = message;
        switch (data.type) {
          case PostMessageTypes.REFRESH_FLOW:
            if (!data.edgeId) {
              atomicQueryUpdate({}, ['edgeId', 'actionId'], this.props.history, true);
            } else {
              this.toggleSelectedEdgeId(data.edgeId, false);
            }
            if (flowId === data.flowId) {
              this.handleRequestFlow();
            }
            break;
          case PostMessageTypes.SELECT_ACTION:
          case PostMessageTypes.ADD_CONTROL:
            {
              if (flowId !== data.flowId) {
                this.forceUpdate();
              }
              break;
            }
          case PostMessageTypes.CLOSE_SIDEPANEL:
            atomicQueryUpdate({}, ['edgeId', 'actionId'], this.props.history, true);
            break;
          case PostMessageTypes.ADD_ALERT:
            {
              const {
                addAlert
              } = this.props;
              const {
                alertType
              } = data;
              if (AlertTypes[alertType]) {
                addAlert(alertType);
              }
              break;
            }
          default:
            break;
        }
      };
      this.getControlDisabledOverride = control => {
        const {
          contextualEmbedReadOnly,
          contextualEmbedReadOnlyMode,
          isContextualEmbed
        } = this.context;
        const {
          getFeaturePermission
        } = this.props;
        const {
          actionLimit
        } = this.state;
        const contextualEmbedReadOnlyOverride = isContextualEmbed && contextualEmbedReadOnly;
        const {
          hasFeatureAccess: hasEditActionAccess
        } = getFeaturePermission({
          feature: EDIT_ACTIONS
        });
        if (hasEditActionAccess) {
          if (control === CONTEXTUAL_CONTROL_OVERRIDES.ADD_ACTION) {
            if (contextualEmbedReadOnlyOverride) {
              if (contextualEmbedReadOnlyMode === 'DELETE_ONLY_OVERRIDE_MODE') {
                return {
                  controlDisabled: true,
                  controlDisabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "automation.common.contextualEmbed.addActionDisabledMessage"
                  })
                };
              }
              return {
                controlDisabled: true,
                controlDisabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.common.readOnlyTooltip"
                })
              };
            } else if (actionLimit.getIsAtOrOverActionLimit()) {
              return {
                controlDisabled: true,
                controlDisabledMessage: getActionLimitMessage(actionLimit)
              };
            }
          } else if (control === CONTEXTUAL_CONTROL_OVERRIDES.EDIT_ACTION) {
            if (contextualEmbedReadOnlyOverride) {
              if (contextualEmbedReadOnlyMode === 'DELETE_ONLY_OVERRIDE_MODE') {
                return {
                  controlDisabled: true,
                  controlDisabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "automation.common.contextualEmbed.editActionDisabledMessage"
                  })
                };
              }
              return {
                controlDisabled: true,
                controlDisabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.common.readOnlyTooltip"
                })
              };
            } else if (actionLimit.getIsOverActionLimit()) {
              return {
                controlDisabled: true,
                controlDisabledMessage: getActionLimitMessage(actionLimit)
              };
            }
          }
        }
        return {
          controlDisabled: false,
          controlDisabledMessage: null
        };
      };
      this.onRenderConnectorButton = ({
        edge,
        readOnly,
        // This read only is passed from DirectedGraph
        isMulti,
        showEdgeTooltips
      }) => {
        const {
          flowId,
          upgradeModalKey
        } = this.props;
        const {
          controlDisabled: addActionDisabled,
          controlDisabledMessage: addActionDisabledMessage
        } = this.getControlDisabledOverride(CONTEXTUAL_CONTROL_OVERRIDES.ADD_ACTION);
        const {
          actionLimit
        } = this.state;
        const actionLimitReached = actionLimit.getIsAtOrOverActionLimit();
        const disabled = addActionDisabled || readOnly;
        const disabledMessage = addActionDisabledMessage || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.readOnlyTooltip"
        });
        return /*#__PURE__*/_jsx(_Fragment, {
          children: actionLimitReached && upgradeModalKey ? /*#__PURE__*/_jsx(ContextualCanvasUpgradeButton, {
            edge: edge,
            disabled: readOnly,
            disabledMessage: disabledMessage,
            upgradeModalKey: upgradeModalKey
          }) : /*#__PURE__*/_jsx(ContextualCanvasAddButton, {
            edge: edge,
            isMulti: isMulti,
            showEdgeTooltips: showEdgeTooltips,
            flowId: flowId,
            onClick: this.onClickAddControl,
            disabled: disabled,
            disabledMessage: disabledMessage
          })
        });
      };
      this.renderLoadingOverlay = () => {
        return /*#__PURE__*/_jsx(StyledFlowContainer, {
          children: /*#__PURE__*/_jsx(UILoadingOverlay, {
            "data-test-id": "contextual-embed-loading-overlay",
            contextual: true,
            layout: "centered"
          })
        });
      };
      this.renderErrorState = () => {
        return /*#__PURE__*/_jsxs(StyledFlowContainer, {
          children: [/*#__PURE__*/_jsx(NavMarker, {
            name: "CONTEXTUAL_AUTOMATION_CONTAINER_ERROR"
          }), /*#__PURE__*/_jsx(ContextualEmbedErrorState, {
            onRetry: () => this.handleRequestFlow()
          })]
        });
      };
      const {
        getLimit,
        appConfigContext: {
          config
        }
      } = _props;
      const currentLimit = config.actionLimit ? getLimit(config.actionLimit) : Infinity;
      this.state = {
        actionLimit: new ActionLimit({
          limit: currentLimit
        })
      };
    }
    componentDidMount() {
      const {
        setBulkProcessingPollingStatus,
        flowId,
        edgeId
      } = this.props;
      this._isMounted = true;
      window.addEventListener('message', this.handleMessage);
      this.handleRequestFlow(this.props);
      this.preloadActionConfigChunks();
      setBulkProcessingPollingStatus(flowId, true);
      this.toggleAddEmptyActionToFlow(edgeId);
      this.pollProcessingStatusId = -1;
    }
    componentDidUpdate({
      flow: prevFlow,
      edgeId: prevSelectedEdgeId,
      flowQuery: prevFlowQuery,
      embedId: prevEmbedId,
      flowId: prevFlowId
    }) {
      const {
        embedId,
        flow,
        flowId,
        flowValidationObjectRequestStatus,
        setBulkProcessingStatus,
        shouldPollBulkProcessing,
        requestFlowValidationObject,
        edgeId: selectedEdgeId,
        flowQuery
      } = this.props;
      if (flow !== prevFlow) {
        this.preloadActionConfigChunks(this.props);
      }
      if (embedId !== prevEmbedId || flowId !== prevFlowId) {
        this.handleRequestFlow(this.props);
      }
      if (!flow && !prevFlowQuery.error && flowQuery.error) {
        sendMessageToParent({
          type: PostMessageTypes.EMBEDDED_FLOW_LOADED,
          embedId,
          flowId
        });
      }
      if (flow) {
        if (!prevFlow) {
          sendMessageToParent({
            type: PostMessageTypes.EMBEDDED_FLOW_LOADED,
            embedId,
            flowId,
            version: flow.getVersion()
          });
          sendMessageToParent({
            type: PostMessageTypes.REFRESH_SIDEPANEL_FLOW_DATA,
            embedId,
            flowId,
            version: flow.getVersion()
          });
        }
        if (getFlowActionCount(prevFlow) !== getFlowActionCount(flow)) {
          this.updateContextualActionLimit();
        }
        this.pollBulkProcessingStatus(flow.getFlowId(), setBulkProcessingStatus, shouldPollBulkProcessing);
        if (prevFlow && flow.getActions() !== prevFlow.getActions() || flowValidationObjectRequestStatus === UNINITIALIZED) {
          requestFlowValidationObject(flow);
        }
      }
      if (selectedEdgeId !== prevSelectedEdgeId) {
        this.toggleAddEmptyActionToFlow(selectedEdgeId);
      }
    }
    componentWillUnmount() {
      this._isMounted = false;
      this.terminateBulkProcessingPolling();
      window.removeEventListener('message', this.handleMessage);
    }
    renderContextualValidationErrorBanner() {
      var _allExtensionDefiniti, _allExtensionDefiniti2;
      const {
        flow,
        allExtensionDefinitionsQuery
      } = this.props;
      const extensionDefinitions = (_allExtensionDefiniti = (_allExtensionDefiniti2 = allExtensionDefinitionsQuery.data) === null || _allExtensionDefiniti2 === void 0 ? void 0 : _allExtensionDefiniti2.allExtensionDefinitions) !== null && _allExtensionDefiniti !== void 0 ? _allExtensionDefiniti : {};
      return /*#__PURE__*/_jsx(ContextualValidationErrorBanner, {
        alerts: this.getActionValidationAlerts(),
        getActionName: getActionHeaderTitle({
          flow,
          extensionDefinitions,
          isUngated: () => false
        }),
        onClickAlert: actionId => this.onSelectAction(actionId, {})
      });
    }
    render() {
      const {
        contextualEmbedReadOnly,
        isContextualEmbed,
        triggerContent
      } = this.context;
      const {
        flow,
        flowId,
        flowQuery,
        flowValidation,
        portalId,
        sourceApp,
        appConfigContext: {
          config
        }
      } = this.props;
      if (!flow) {
        if (flowQuery.loading) {
          return this.renderLoadingOverlay();
        } else if (flowQuery.error) {
          return this.renderErrorState();
        }
        return null;
      }
      if (config.shouldCollapseFlowsWithBranches && flow.hasBranchActions()) {
        const workflowsURL = `https://${window.location.host}/workflows/${portalId}${getFlowEditRoute(flowId)}`;
        return /*#__PURE__*/_jsx(StyledFlowContainer, {
          isDisabled: !getIsEnabled(flow),
          children: /*#__PURE__*/_jsxs(StyledRoot, {
            "data-test-id": "flow-canvas-container",
            children: [/*#__PURE__*/_jsx(NavMarker, {
              name: "CONTEXTUAL_AUTOMATION_CONTAINER"
            }), /*#__PURE__*/_jsx(EmbeddedCollapsedFlowAlert, {
              href: workflowsURL,
              onClick: this.onClickNavigateToFullApp
            })]
          })
        });
      }
      const displayContextualValidationErrorBanner = !!(flow && getIsEnabled(flow) && flowValidation && flowValidation.getAllActionErrors().size);
      const contextualEmbedReadOnlyOverride = isContextualEmbed && contextualEmbedReadOnly;
      return /*#__PURE__*/_jsxs(DataSourcesProviderWrapper, {
        flowId: flowId,
        sourceAppId: sourceApp,
        children: [flow && /*#__PURE__*/_jsx(NavMarker, {
          name: "CONTEXTUAL_AUTOMATION_CONTAINER"
        }), /*#__PURE__*/_jsxs(StyledFlowContainer, {
          ref: this.scrollElementRef,
          className: "p-top-4",
          isDisabled: !getIsEnabled(flow),
          shouldScrollHorizontally: config.shouldScrollHorizontally,
          children: [displayContextualValidationErrorBanner && this.renderContextualValidationErrorBanner(), /*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
            isEmbedded: true,
            isMulti: false,
            onClickAddControl: this.onClickAddControl,
            onRenderCanvasNode: this.onRenderCanvasNode,
            onRenderConnectorButton: this.onRenderConnectorButton,
            onSelectAction: this.onSelectAction,
            ComposedCanvas: this.ComposedCanvas,
            canvasScrollElementRef: this.scrollElementRef,
            centerOnMount: centerOnMount
          }), `readOnlyOverride:${contextualEmbedReadOnlyOverride}-triggerContent:${triggerContent}`)]
        })]
      });
    }
  }

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  ContextualAutomationContainer.contextType = AppContext;
  ContextualAutomationContainer.defaultProps = defaultProps;
  ContextualAutomationContainer.defaultProps = {
    columnWidth: 600
  };
  const ConnectedContextualAutomationContainer = compose(withFeaturePermissions, withRouter, wireAuthConsumer, _WrappedComponent => props => {
    const parsedQuery = parseLocation(props.location);
    const flowId = Number(parsedQuery.flowId);
    return /*#__PURE__*/_jsx(_WrappedComponent, Object.assign({}, props, {
      flowId: flowId
    }));
  }, wireFlowById, withFlpAccess, connect((state, {
    location,
    match,
    hasScope,
    flow,
    flowId
  }) => {
    const {
      actionType: selectedActionTypePath = null
    } = match.params;
    const parsedQuery = parseLocation(location);
    const embeddedSelectedActionId = parsedQuery.actionId;
    const workflowId = flow && flow.getWorkflowId();
    const highlightedActionIds = getHighlightedActionIds(state);
    const flowValidation = getFlowValidation(flowId)(state);
    const selectedActionMetadataConfig = selectedActionTypePath ? basePathToActionMetadataConfig(selectedActionTypePath, parsedQuery) : null;
    const hasWorkflowsAppAccess = hasScope(Scopes.WORKFLOWS_APP_ACCESS);
    return {
      flowValidationObjectRequestStatus: getFlowValidationObjectRequestStatus(state),
      workflowId,
      flowValidation,
      sourceApp: getSourceApp(state),
      selectedActionId: embeddedSelectedActionId,
      selectedActionMetadataConfig,
      embedId: getEmbedId(state),
      edgeId: parsedQuery.edgeId,
      portalId: state.auth.portal.portal_id,
      columnWidth: parsedQuery.columnWidth ? Number(parsedQuery.columnWidth) : undefined,
      highlightedActionIds,
      shouldPollBulkProcessing: getShouldPollBulkProcessing(flowId)(state),
      hasWorkflowsAppAccess,
      showEdgeTooltips: true,
      isCanvasVirtualRenderingDisabled: getIsCanvasVirtualRenderingDisabled(state)
    };
  }, {
    addAlert: _addAlert,
    setBulkProcessingStatus: platformFlowsApplicationActions.setBulkProcessingStatus,
    setBulkProcessingPollingStatus: platformFlowsApplicationActions.setBulkProcessingPollingStatus,
    updateFlowLocally: flowActions.updateFlowLocally,
    requestFlowValidationObject: flowActions.requestFlowValidationObject
  }), queryObjectsInActionsPolling, _WrappedComponent => props => wireActionOutputs(_WrappedComponent, {
    flow: props.flow
  })(props), _WrappedComponent => props => {
    const {
      flow
    } = props;
    const flowObjectTypeId = getObjectTypeId(flow); // for queryAllExtensionDefinitions
    const flowSourceApp = getFlowSourceApp(flow); // for queryAllExtensionDefinitions
    return /*#__PURE__*/_jsx(_WrappedComponent, Object.assign({}, props, {
      flowObjectTypeId: flowObjectTypeId,
      flowSourceApp: flowSourceApp
    }));
  }, wireUpdateFlow, queryAllExtensionDefinitions,
  // Requires flowSourceApp and flowObjectTypeId
  wireAppConfigConsumer)(ContextualAutomationContainer);
  ConnectedContextualAutomationContainer.displayName = `ConnectedContextualAutomationContainer(${componentName})`;
  attachWrappedComponent(ConnectedContextualAutomationContainer, WrappedComponent);
  return ConnectedContextualAutomationContainer;
}